<template>
  <ul class="nav nav-tabs">
    <li :class="{ active: isActiveTab('OperatorGeneralSettings') }">
      <router-link
        :to="{ name: 'OperatorGeneralSettings', params: { id: operatorId } }"
        >{{ $label("operator.base_data_tab", "General") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('operatorInvoiceSettings') }">
      <router-link
        :to="{ name: 'operatorInvoiceSettings', params: { id: operatorId } }"
        >{{
          $label("operator.invoice_settings_tab", "Invoicing settings")
        }}</router-link
      >
    </li>

    <!-- <li :class="{ 'active': isActiveTab('operatorSmsQuota') }">
            <router-link :to="{ name: 'operatorSmsQuota', params: {'id': operatorId} }">{{ $label('operator.sms_quota_tab') }}</router-link>
        </li> -->

    <li :class="{ active: isActiveTab('operatorEmailSettings') }">
      <router-link
        :to="{ name: 'operatorEmailSettings', params: { id: operatorId } }"
        >{{
          $label("operator.email_settings_tab", "E-Mail settings")
        }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('AdditionalOperators') }">
      <router-link :to="{ name: 'AdditionalOperators' }">{{
        $label("operator.additional_operators_tab", "Additional operators")
      }}</router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["operatorId"],

  methods: {
    isActiveTab(tab) {
      return this.$route.name == tab;
    }
  }
};
</script>
